const contextNameToEventMap = {
  keydown: '-keydown',
  visibility: '-visibility',
  size: '-size'
};
const shouldPersistContextValue = {
  keydown: false,
  visibility: true,
  size: true
};
export class Context {
  #$root;
  #listeners = new Set();
  #name;
  #isListening = false;
  #lastContextValue = null;
  constructor($element, name) {
    this.#$root = $element;
    this.#name = name;
  }
  listen(signal) {
    if (this.#isListening) {
      return;
    }
    this.#$root.addEventListener(`-context-connect-${this.#name}`, this.#onListenerConnect, {
      signal
    });
    this.#$root.addEventListener(`-context-disconnect-${this.#name}`, this.#onListenerDisconnect, {
      signal
    });
    this.#isListening = true;
    signal.addEventListener('abort', () => {
      this.#listeners.clear();
      this.#isListening = false;
      this.#lastContextValue = null;
    }, {
      once: true
    });
  }
  dispatch(contextValue) {
    for (const el of this.#listeners) {
      el.dispatchEvent(new CustomEvent(contextNameToEventMap[this.#name], {
        detail: contextValue
      }));
    }
    if (shouldPersistContextValue[this.#name]) {
      this.#lastContextValue = contextValue;
    }
  }
  #onListenerConnect = e => {
    e.stopPropagation();
    this.#listeners.add(e.detail);
    if (this.#lastContextValue !== null) {
      e.detail.dispatchEvent(new CustomEvent(contextNameToEventMap[this.#name], {
        detail: this.#lastContextValue
      }));
    }
  };
  #onListenerDisconnect = e => {
    e.stopPropagation();
    this.#listeners.delete(e.detail);
  };
}
export const subscribeContext = ($el, name, cb, signal) => {
  requestAnimationFrame(() => {
    $el.dispatchEvent(new CustomEvent(`-context-connect-${name}`, {
      bubbles: true,
      composed: true,
      detail: $el
    }));
  });
  $el.addEventListener(contextNameToEventMap[name], cb, {
    signal
  });
  signal.addEventListener('abort', () => {
    $el.dispatchEvent(new CustomEvent(`-context-disconnect-${name}`, {
      bubbles: true,
      composed: true,
      detail: $el
    }));
  }, {
    once: true
  });
};